import axios from 'axios';
import { encode } from 'base-64';

const axiosInstance = axios.create({
  baseURL: '/comExec/api/index.php?api_path=',
});

export const aptInfo = async (domain) => {
  return await axiosInstance({
    method: 'GET',
    url: `/apt/boot?host=${domain}`,
  })
    .then((res) => res.data)
    .catch((err) => console.log(err));
};

export const login = async ({ id, password, domain }) => {
  const credential = encode(`${id}@${domain}:${password}`);

  return await axiosInstance({
    url: '/token/issue',
    method: 'POST',
    headers: {
      Authorization: `Basic ${credential}`,
      accept: 'application/json',
      'Content-type': 'application/json',
    },
    data: {
      extend: false,
    },
  })
    .then((res) => {
      if (res.status === 201) {
        return res.data;
      } else {
        return res.status;
      }
    })
    .catch((err) => err.response.status);
};
